import { render, staticRenderFns } from "./CruiseOverviewPage.vue?vue&type=template&id=03b943c4&"
import script from "./CruiseOverviewPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./CruiseOverviewPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports